import { TextField as MuiTextField } from '@mui/material'
import type { FieldMeta } from '@crm/shared'

interface TextFieldProps {
  field: FieldMeta
  value: unknown
  mode: 'view' | 'edit'
  onChange?: (value: unknown) => void
  error?: string
  disabled?: boolean
  hideLabel?: boolean
}

export function TextField({ field, value, mode, onChange, error, disabled, hideLabel }: TextFieldProps) {
  if (mode === 'view') {
    return <span>{value != null ? String(value) : ''}</span>
  }

  return (
    <MuiTextField
      label={hideLabel ? undefined : field.label}
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
      error={!!error}
      helperText={error}
      disabled={disabled}
      required={!!field.is_required}
      size="small"
      fullWidth
      slotProps={{ htmlInput: { maxLength: 255 } }}
    />
  )
}
